import { useState } from "react";
import { faqData } from "@/mocks/comics";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <section className="w-full py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}>
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              关于韩漫网，您可能想了解这些
            </p>
          </div>

          <div className="max-w-3xl space-y-3">
            {faqData.map((item, index) => (
              <div
                key={index}
                className="bg-background-100 rounded-lg overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {item.question}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`text-base text-foreground-400 transition-transform duration-300 ${
                        openIndex === index ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </span>
                </button>
                {openIndex === index && (
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}